// Unified motion system — clean, consistent fade-ups with a single easing curve.

/** Standard easing curve for all content animations */
export const EASE = [0.16, 1, 0.3, 1] as const;

/** Snappier easing for UI interactions (navbar, dropdowns, toggles) */
export const EASE_UI = [0.22, 1, 0.36, 1] as const;

export const VIEWPORT = { once: true, margin: "-8%" } as const;

/** Fade-up for content blocks */
export const fadeIn = (delay = 0) => ({
  initial: false as const,
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT,
  transition: { duration: 0.5, ease: EASE, delay },
});

/** Heading reveal — slightly slower for emphasis */
export const headingReveal = (delay = 0) => ({
  initial: false as const,
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT,
  transition: { duration: 0.6, ease: EASE, delay },
});

/** @deprecated Use headingReveal instead */
export const clipReveal = headingReveal;

/** Item fade-up for lists/grids — subtle stagger for premium feel */
export const staggerItem = (index: number, baseDelay = 0) => ({
  initial: false as const,
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT,
  transition: { duration: 0.5, ease: EASE, delay: baseDelay + index * 0.06 },
});
